import React from 'react';

import facility from 'app/facility';
import Checkbox from 'app/commonComponents/Checkbox';

function NewsletterCheckbox(props) {
  const { name, widgetNewsletterSignupText } = facility.settings;

  if (widgetNewsletterSignupText) {
    const label = widgetNewsletterSignupText.replaceAll('%s', name);
    return <Checkbox label={label} {...props} />;
  }

  const defaultLabel = i18n.sprintf(
    i18n.gettext('Yes, I want to receive exclusive offers via email from %s'),
    name
  );
  return <Checkbox label={defaultLabel} {...props} />;
}

export default NewsletterCheckbox;
